import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'menuProductFilter',
    pure: true,
    standalone: true
})
export class MenuProductFilterPipe implements PipeTransform {

  transform(products: any, category_id?: any): any[] {
    return products.filter(product => product.category_id === category_id).sort((a, b) => a.sold_out - b.sold_out);
  }

}
